import { Card } from "antd";
import { BookOutlined, RobotOutlined, TeamOutlined, FileTextOutlined } from "@ant-design/icons";

const features = [
    {
        icon: <BookOutlined className="text-xl text-purple-500" />,
        title: "Industry-oriented curriculum",
        description: "An updated curriculum engineered to teach you only what the industry demands.",
    },
    {
        icon: <RobotOutlined className="text-xl text-blue-500" />,
        title: "AI-driven learning products",
        description: "AI-based IDE with real-time support and help, AI-based mock interviews, evaluation systems.",
    },
    {
        icon: <TeamOutlined className="text-xl text-green-500" />,
        title: "Experienced Instructors",
        description: "Courses taught only by people who have already aced it! 50+ tech professionals to guide you.",
    },
    {
        icon: <FileTextOutlined className="text-xl text-orange-500" />,
        title: "50+ mock interviews",
        description: "Practice your skills with unlimited number of mock interviews you can schedule yourself.",
    },
];

export default function FeaturesSection() {
    return (
        <section className="p-6 section">
            {/* Heading Section */}
            <div className="mb-6">
                <p className="text-xs uppercase font-semibold text-gray-500">Why Pronttera Lab</p>
                <h2 className="text-2xl font-bold text-gray-800">Industry-tailored learning</h2>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {features.map((feature, index) => (
                    <Card key={index} className="shadow-md border rounded-lg p-4">
                        <div className="flex items-start gap-4">
                            <div className="text-2xl">{feature.icon}</div>
                            <div>
                                <h3 className="text-lg font-semibold">{feature.title}</h3>
                                <p className="text-gray-600">{feature.description}</p>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>

            {/* Footer Text */}
            <div className="text-center font-semibold text-gray-700 mt-6">
                Get started on your journey towards unlocking hundreds of job opportunities with Pronttera Labs
            </div>
        </section>
    );
}
